import React from 'react';
import pluralize from 'pluralize';
import Pill from '@/components/ui/Pill';

interface CorrelationCountPillProps {
  count: number;
  // Direct = a TAGGABLE leaf's own correlations. Rolled-up = the sum across a grouping node's
  // descendants. Per DESIGN-340: any zero = grey fill ("dimmed/empty"); a leaf with correlations
  // = purple fill (actionable); a grouping node with correlations = white outline (passive).
  direct: boolean;
}

const CorrelationCountPill = ({ count, direct }: CorrelationCountPillProps) => (
  <Pill
    outline={!direct && count > 0}
    pillClassName="tw-text-xs tw-font-normal tw-whitespace-nowrap"
    pillColor={direct && count > 0 ? 'purple' : 'grey'}
  >
    {pluralize('correlation', count, true)}
  </Pill>
);

export default CorrelationCountPill;
